import React, { useRef } from 'react';
import { Options, noUiSlider as NoUiSlider } from 'nouislider';
import { Slider, SliderProps } from '../Slider';
import { Container, Field, Input, Label } from './styles';

export interface InputSliderProps extends SliderProps {
  id?: string;
  label?: string;
  withModal?: boolean;
}

export const InputSlider = (props: InputSliderProps & Options) => {
  const { id = 'amount', label, value, withModal, step, ...other } = props;
  const noUiSliderRef = useRef<NoUiSlider>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  let additionalParams;

  const stopEvent = (e: Event) => {
    e.stopPropagation();
  };

  // withModal - если слайдер находится в модалке, чтобы эвенты слайдера не влияли на события модалки
  if (withModal) {
    additionalParams = {
      onStart: () => {
        document.body.addEventListener('mouseup', stopEvent, true);
        document.body.addEventListener('click', stopEvent, true);
      },
      onEnd: () => {
        document.body.removeEventListener('click', stopEvent, true);
        document.body.removeEventListener('mouseup', stopEvent, true);
      }
    };
  }

  const onInputChange = () => {
    if (inputRef.current) {
      noUiSliderRef.current?.set(+inputRef.current.value || 0);
    }
  };

  return (
    <Container>
      <Slider
        height={60}
        value={value}
        {...other}
        {...additionalParams}
        instance={instance => (noUiSliderRef.current = instance)}
        onUpdate={values => {
          if (inputRef.current && inputRef.current.value !== '') {
            inputRef.current.value = parseFloat(values[0]).toString();
          }
        }}
      >
        <Field>
          {label && <Label htmlFor={id}>{label}</Label>}
          <Input
            id={id}
            ref={inputRef}
            defaultValue={value}
            onChange={onInputChange}
            onBlur={e => {
              if (inputRef.current && e.target.value === '') {
                inputRef.current.value = '0';
              }
            }}
            step={step}
            type="number"
            inputMode="decimal"
            onKeyDown={event => {
              const allowedKeys = [
                'Backspace',
                'Enter',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'ArrowUp',
                'ArrowDown'
              ];
              if (
                !allowedKeys.includes(event.key) &&
                !event.ctrlKey &&
                !event.key.match(/\d|\.|\,/g)
              ) {
                event.preventDefault();
              }
            }}
          />
        </Field>
      </Slider>
    </Container>
  );
};
